interface RespellingData {
  valid: boolean;
  replacement: string;
}

const VALID_RESPELL = /^((([A-Z]+|[a-z]+)-)+)?([A-Z]+|[a-z]+)$/;
const DOUBLE_COLONS = /^::.*::$/;

// Allowed: letters except q/x, and hyphen
const ALLOWED_RESPELL_CHAR = /[A-PR-WYZa-pr-wyz-]/;

const isTextValidRespelling = (text: string): boolean => {
  if (/[qx]/i.test(text)) return false;
  return !!text.match(VALID_RESPELL);
};

export const getInvalidRespellingChars = (text: string): string => {
  const normalizedSet = new Set(
    [...text]
      .filter(c => !ALLOWED_RESPELL_CHAR.test(c))
      .map(c => (c === ' ' ? 'space' : c))
  );
  const invalid = [...normalizedSet].sort().join(', ');
  return invalid;
};

export const isReplacementValidRespelling = (text: string): RespellingData => {
  let valid = DOUBLE_COLONS.test(text);
  let replacement = text;
  if (valid) {
    const content = text.substring(2, text.length - 2);
    valid = isTextValidRespelling(content);
    if (valid) {
      replacement = content;
    }
  }

  return {
    valid,
    replacement,
  };
};

// Note this is checking user input. User is expected to NOT use double colons.
export const isInputValidRespelling = (text: string): boolean => {
  return isTextValidRespelling(text);
};

export const hasInputDoubleColons = (text: string): boolean => {
  return !!text.match(DOUBLE_COLONS);
};

/** Format comma-separated invalid chars as "q or x" or "q, Q, or x". */
export const formatInvalidCharsForMessage = (text: string): string => {
  const invalidChars = getInvalidRespellingChars(text);
  if (!invalidChars.trim()) return '';
  const parts = invalidChars
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return `${parts[0]} or ${parts[1]}`;
  return `${parts.slice(0, -1).join(', ')}, or ${parts[parts.length - 1]}`;
};

export const convertReplacementForDB = (
  replacement: string,
  isRespell: boolean
): string => {
  if (isRespell) {
    return `::${replacement}::`;
  }
  return replacement;
};
